import { inject, Injectable, OnDestroy, computed, Signal } from '@angular/core';
import { Subject } from 'rxjs';
import { PrivilegesService } from '@shared/privileges/privileges.service';

export class CategoryDetailIdentifier {
  profileId: number;
  categoryId: number;
  selectedInvolvementType: any;
  selectedInvolvementDetail: any;
  selectedQuestion: any;
  selectedAnswer: any;
  hasEditAccess = false;
  questionsNtFound: any;
}

@Injectable({
  providedIn: 'root'
})
export class CategoryDetailService implements OnDestroy {
  destroy$: Subject<void> = new Subject<void>();

  readonly #privilegesService = inject(PrivilegesService);
  readonly canAdminFillOutReport = this.#privilegesService.isCurrentUserFillOutReportAdmin; // feature flag for admin capabilities for the new fill out report (i.e. templates/involvements/etc)

  // Observable string sources
  private readonly categoryInitializedSource = new Subject<string>();
  private readonly answerAddedSource = new Subject<any>();
  private readonly questionAddedorModifiedSource = new Subject<string>();

  // Observable string streams
  categoryInitialized$ = this.categoryInitializedSource.asObservable();
  answerAdded$ = this.answerAddedSource.asObservable();
  questionAddedorModified$ = this.questionAddedorModifiedSource.asObservable();


  // Persist some details about selected category detail so we dont need to pass it around from component to component.
  state: CategoryDetailIdentifier = new CategoryDetailIdentifier();

  constructor() { }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  public initializeCategory(data: any) {
    this.categoryInitializedSource.next(data);
  }

  public answerAdded(data: any) {
    this.answerAddedSource.next(data);
  }

  public questionAddedorModified(data: any) {
    this.questionAddedorModifiedSource.next(data);
  }

  public setState(profileId: number, categoryId: number) {
    this.state.profileId = profileId;
    this.state.categoryId = categoryId;
  }
  public clearState() {
    this.state.profileId = 0;
    this.state.categoryId = 0;
    this.state.selectedInvolvementType = null;
  }

  public setSelectedQuestion(question: any) {
    this.state.selectedQuestion = question;
  }
  public setSelectedAnswer(answer: any) {
    this.state.selectedAnswer = answer;
  }
  public clearSelectedAnswer() {
    this.state.selectedAnswer = null;
  }
  public setEditAccess(hasAccess: any) {
    this.state.hasEditAccess = hasAccess;
  }
}


